export const RESIDENTIAL_TYPE = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Single House'
}, {
	code: '2',
	value: 'Duplex'
}, {
	code: '3',
	value: 'Apartment/Row House'
}, {
	code: '4',
	value: 'Other multi unit residential'
}]

export const FLOORS_NUMBER = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'One floor'
}, {
	code: '2',
	value: 'Two floors'
}, {
	code: '3',
	value: 'Three floors'
}, {
	code: '4',
	value: 'Four floors'
}]

export const ROOF_MATERIALS = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Galvanized iron / aluminum'
}, {
	code: '2',
	value: 'Concrete / Clay tile'
}, {
	code: '3',
	value: 'Half galvanized iron and half concrete'
}, {
	code: '4',
	value: 'Wood / Bamboo'
}, {
	code: '5',
	value: 'Cogon / Nipa / Anahaw'
}, {
	code: '6',
	value: 'Makeshift / Salvaged / Improvised Materials'
}, {
	code: '7',
	value: 'Other specify'
}]

export const OUTERWALLS_MATERIALS = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Concrete / Brick / Stone'
}, {
	code: '2',
	value: 'Wood'
}, {
	code: '3',
	value: 'Half concrete / Brick / Stone and half wood'
}, {
	code: '4',
	value: 'Galvanized iron aluminum'
}, {
	code: '5',
	value: 'Bamboo / Sawali / Cogon / Nipa'
}, {
	code: '6',
	value: 'Makeshift / Salvaged / Improvised Materials'
}, {
	code: '7',
	value: 'Other specify'
}]

export const FLOOR_FINISHING_MATERIALS = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Ceramic tile / Marble / Granite'
}, {
	code: '2',
	value: 'Cement brick stone'
}, {
	code: '3',
	value: 'Wood plank'
}, {
	code: '4',
	value: 'Vinyl'
}, {
	code: '5',
	value: 'Linoleum'
}, {
	code: '6',
	value: 'Other specify'
}]

export const FLOOR_CONSTRUCTION_MATERIALS = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Concrete / Brick /Stone'
}, {
	code: '2',
	value: 'Wood'
}, {
	code: '3',
	value: 'Coconut lumber'
}, {
	code: '4',
	value: 'Bamboo'
}, {
	code: '5',
	value: 'Earth / Sand / Mud'
}, {
	code: '6',
	value: 'Makeshift / Salvaged / Improvised Materials'
}, {
	code: '7',
	value: 'Other specify'
}]

export const REPAIR_STATE = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Needs no repair / Need minor repair'
}, {
	code: '2',
	value: 'Need major repair'
}, {
	code: '3',
	value: 'Dilapidated / Condemned'
}, {
	code: '4',
	value: 'Under renovation / Being repaired'
}, {
	code: '5',
	value: 'Under construction (on-going)'
}, {
	code: '6',
	value: 'Unfinished construction'
}]

export const BUILT_YEAR = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: '2021'
}, {
	code: '2',
	value: '2020'
}, {
	code: '3',
	value: '2019'
}, {
	code: '4',
	value: '2018'
}, {
	code: '5',
	value: '2017'
}, {
	code: '6',
	value: '2011 - 2016'
}, {
	code: '7',
	value: '2001 - 2010'
}, {
	code: '8',
	value: '1991 - 2000'
}, {
	code: '9',
	value: '1981 - 1990'
}, {
	code: '10',
	value: '1980 or earlier'
}, {
	code: '11',
	value: 'Don\'t know'
}]

export const FLOOR_AREA = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Less than 10 square meter'
}, {
	code: '2',
	value: '10 - 19 square meter'
}, {
	code: '3',
	value: '20 - 29 square meter'
}, {
	code: '4',
	value: '30 - 39 square meter'
}, {
	code: '5',
	value: '40 - 49 square meter'
}, {
	code: '6',
	value: '50 - 59 square meter'
}, {
	code: '7',
	value: '60 - 69 square meter'
}, {
	code: '8',
	value: '70 - 79 square meter'
}, {
	code: '9',
	value: '80 - 89 square meter'
}, {
	code: '10',
	value: '90 - 99 square meter'
}, {
	code: '11',
	value: '100 - 120 square meter'
}, {
	code: '12',
	value: '120 - 149 square meter'
}, {
	code: '13',
	value: '150 - 199 square meter'
}, {
	code: '14',
	value: '200 square meter above'
}]

export const TENURE_STATUS = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Own or owner like possession of the housing unit'
}, {
	code: '2',
	value: 'Rent house / room'
}, {
	code: '3',
	value: 'Rent free house with the consent of owner'
}, {
	code: '4',
	value: 'Rent free house and lot without consent of owner'
}]

export const HOUSE_ACQUISITION = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Inherited'
}, {
	code: '2',
	value: 'Gift / Awarded'
}, {
	code: '3',
	value: 'Purchased'
}, {
	code: '4',
	value: 'Company benefit'
}, {
	code: '5',
	value: 'Other specify'
}]

export const MONTHLY_RENTAL = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Php 1,000 or less'
}, {
	code: '2',
	value: 'Php 1,001 or 1,500'
}, {
	code: '3',
	value: 'Php 1,501 or 2,000'
}, {
	code: '4',
	value: 'Php 2,001 - 2,500'
}, {
	code: '5',
	value: 'Php 2,501 - 4,000'
}, {
	code: '6',
	value: 'Php 4,001 - 5,000'
}, {
	code: '7',
	value: 'Php 5,001 - 7,000'
}, {
	code: '8',
	value: 'Php 7,501 - 10,000'
}, {
	code: '9',
	value: 'Php 10,001 - over'
}]

export const GARBAGE_DISPOSAL = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Picked up by garbage truck'
}, {
	code: '2',
	value: 'Dumping individuals pit (not burned)'
}, {
	code: '3',
	value: 'Burning'
}, {
	code: '4',
	value: 'Composting'
}, {
	code: '5',
	value: 'Burying'
}, {
	code: '6',
	value: 'Other specify'
}]

export const TOILET_FACILITY = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Flush to septic tank'
}, {
	code: '2',
	value: 'Flush to pit latrine'
}, {
	code: '3',
	value: 'Flush to open drain'
}, {
	code: '4',
	value: 'Flush to unknown depository / place'
}, {
	code: '5',
	value: 'Ventilated improvised latrine'
}, {
	code: '6',
	value: 'Pit latrine with slab'
}, {
	code: '7',
	value: 'Pit latrine without slab / open pit'
}, {
	code: '8',
	value: 'Composting toilet'
}, {
	code: '9',
	value: 'Bucket / Pail system'
}, {
	code: '10',
	value: 'Hanging toilet / Hanging latrine'
}, {
	code: '11',
	value: 'No facility'
}, {
	code: '12',
	value: 'other specify'
}]

export const LIGHTING_FUEL = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Electricity'
}, {
	code: '2',
	value: 'Kerosene (Gaas)'
}, {
	code: '3',
	value: 'Liquid Petroleum Gas (LPG)'
}, {
	code: '4',
	value: 'Solar panel / Solar lamp'
}, {
	code: '5',
	value: 'Other specify'
}]

export const COOKING_FUEL = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Electricity'
}, {
	code: '2',
	value: 'Kerosene (Gaas)'
}, {
	code: '3',
	value: 'Liquid Petroleum Gas (LPG)'
}, {
	code: '4',
	value: 'Charcoal'
}, {
	code: '5',
	value: 'Wood'
}, {
	code: '6',
	value: 'Other specify'
}]

export const WATER_SUPPLY_DRINKING = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Own use faucet, community water system'
}, {
	code: '2',
	value: 'Shared faucet, community water system'
}, {
	code: '3',
	value: 'Own use tubed / Piped deep well'
}, {
	code: '4',
	value: 'Shared tubed / Piped deep well'
}, {
	code: '5',
	value: 'Protected well'
}, {
	code: '6',
	value: 'Unprotected well'
}, {
	code: '7',
	value: 'Protected spring'
}, {
	code: '8',
	value: 'Unprotected spring'
}, {
	code: '9',
	value: 'Rainwater'
}, {
	code: '10',
	value: 'Surface water'
}, {
	code: '11',
	value: 'Water refilling station'
}, {
	code: '12',
	value: 'Bottled water'
}, {
	code: '13',
	value: 'Other specify'
}]

export const WATER_SUPPLY_COOKING = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Own use faucet, community water system'
}, {
	code: '2',
	value: 'Shared faucet, community water system'
}, {
	code: '3',
	value: 'Own use tubed / Piped deep well'
}, {
	code: '4',
	value: 'Shared tubed / Piped deep well'
}, {
	code: '5',
	value: 'Protected well'
}, {
	code: '6',
	value: 'Unprotected well'
}, {
	code: '7',
	value: 'Protected spring'
}, {
	code: '8',
	value: 'Unprotected spring'
}, {
	code: '9',
	value: 'Rainwater'
}, {
	code: '10',
	value: 'Surface water'
}, {
	code: '11',
	value: 'Water refilling station'
}, {
	code: '12',
	value: 'Bottled water'
}, {
	code: '13',
	value: 'Other specify'
}]

export const LAND_LOCATION = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Inside 10.8 hectares'
}, {
	code: '2',
	value: 'Outside 10.8 hectares'
}]

export const LAND_OWNERSHIP = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Other residential lands'
}, {
	code: '2',
	value: 'Agricultural land/s'
}, {
	code: '3',
	value: 'Agricultural land/s acquired through comprehensive agrarian reform program, as an agrarian beneficiary'
}, {
	code: '4',
	value: 'Other land/s specify'
}]

export const PRESENCE_OPERATOR = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Crop farm'
}, {
	code: '2',
	value: 'Livestock and / or poultry farm'
}, {
	code: '3',
	value: 'Fishing Activity'
}, {
	code: '4',
	value: 'Other farm activity, specify'
}]